import React, { useState, useEffect } from 'react'
import httpClient from '../components/helpers/httpClient'
import './MobileLoginPage.css'
import { useNavigate, Link, useSearchParams } from "react-router-dom"
import { useDispatch } from "react-redux"
import CircularProgress from '@mui/material/CircularProgress'
import { toast } from "react-toastify"
import { addUserInfo } from "../store/user"
import logo_white from "../assets/logos/Logo-Vitruvi-transparant_Wit.png"

const getSafeRedirectPath = (redirect) => {
  if (!redirect || !redirect.startsWith('/') || redirect.startsWith('//')) return '/dashboard'
  return redirect
}

export default function MobileLoginPage() {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [loading, setLoading] = useState(false)
  const [checkingAuth, setCheckingAuth] = useState(true)

  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const dispatch = useDispatch()
  const redirectPath = getSafeRedirectPath(searchParams.get('redirect'))

  // Check if user is already logged in
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await httpClient.get(import.meta.env.VITE_API_URL + "/api/auth/check")
        if (response.status === 200 && response.data.authenticated) {
          dispatch(addUserInfo(response.data.user))
          navigate(redirectPath, { replace: true })
        }
      } catch (error) {
        // Not authenticated, stay on login page
      }
      setCheckingAuth(false)
    }
    checkAuth()
  }, [])

  const logInUser = async () => {
    setLoading(true)

    try {
      const data = { email, password }
      const response = await httpClient.post(import.meta.env.VITE_API_URL + "/api/login", data)

      dispatch(addUserInfo(response.data))

      if (response.data.type === "TBA") {
        toast.error("You have not been authorized yet. Contact admin.")
      } else {
        navigate(redirectPath, { replace: true })
      }
    } catch (error) {
      if (error.response?.status === 401) {
        toast.error("Email and/or password not correct")
      } else {
        toast.error("An error occurred. Please try again.")
      }
    } finally {
      setLoading(false)
    }
  }

  const handleEnter = (event) => {
    if (event.key === "Enter") {
      event.preventDefault()
      logInUser()
    }
  }

  if (checkingAuth) {
    return (
      <div className="mobile-login-page">
        <div className="mobile-login-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <CircularProgress color="inherit" />
        </div>
      </div>
    )
  }

  return (
    <div className="mobile-login-page">
      <div className="mobile-login-container">
        <img src={logo_white} alt="Vitruvi logo" className="mobile-login-logo" />   
             
        <div className="mobile-login-form">
          <div className="mobile-input-group">
            <input
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder='EMAIL'
              onKeyDown={handleEnter}
              className="mobile-login-input"
              type="email"
            />
          </div>
          <div className="mobile-input-group">
            <input
              value={password}
              onChange={e => setPassword(e.target.value)}
              type='password'
              placeholder='PASSWORD'
              onKeyDown={handleEnter}
              className="mobile-login-input"
            />
          </div>

          <button 
            type='button' 
            className='mobile-login-button' 
            onClick={logInUser} 
            disabled={loading}
          >
            {loading ? <CircularProgress color="inherit" size={24} /> : "LOG IN"}
          </button>
          
          <div className="mobile-login-footer">
            <Link to='/forgotpassword'>Forgot password?</Link>
          </div>
        </div>
      </div>
    </div>
  )
}

